import * as React from 'react'
import { ReactElement } from 'react'
import { useFormikContext } from 'formik'
import { DateTime } from 'luxon'
import LegacyLocalDatePicker from '../../../../components/LegacyLocalDatePicker'
import { getDropdownProps } from '../../../../helpers/formHelper'
import LegacyUserDropdown from '../../../Dropdown/LegacyUserDropdown'
import ReportForm from './ReportForm'
import { DocumentGenerationType } from '../../../../hooks/document/useDocumentGenerationHandler'

export type OngoingFilesReportDto = {
    to: string
    itemUsers: string[]
    statuses: string[]
}

function ReportBody(): ReactElement {
    const { errors, values, setFieldValue } = useFormikContext<OngoingFilesReportDto>()
    return (
        <>
            <LegacyLocalDatePicker
                value={values.to}
                onSelectDate={date => setFieldValue('to', date)}
                datePickerProps={{
                    label: 'Datum tot',
                    maxDate: new Date(),
                }}
            />
            <LegacyUserDropdown
                label="Uitvoerder"
                {...getDropdownProps(
                    values.itemUsers,
                    errors?.itemUsers,
                    value => setFieldValue('itemUsers', value),
                    true,
                )}
                placeholder={'Selecteer gebruiker'}
                required={false}
            />
        </>
    )
}

export default function OngoingFilesReportForm(): ReactElement {
    return (
        <ReportForm<OngoingFilesReportDto>
            title="Lopende dossiers"
            generationType={DocumentGenerationType.OngoingFiles}
            initialValues={{
                to: DateTime.local().toISODate(),
                itemUsers: [],
                statuses: [],
            }}
        >
            <ReportBody />
        </ReportForm>
    )
}
